import { render, staticRenderFns } from "./PayrollTypeList.vue?vue&type=template&id=cc6403b8"
import script from "./PayrollTypeList.vue?vue&type=script&lang=js"
export * from "./PayrollTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports